// Sense brand color - hardcoded as this is used for preset color palette, not dynamic theming
const SENSE_BRAND_COLOR = '#0059A8'

export const COLORS = [
    { value: '#41BBD9', label: 'Scooter' },
    { value: '#89FC00', label: 'Chartreuse' },
    { value: '#CB9CF2', label: 'Perfume' },
    { value: '#FFBF00', label: 'Amber' },
    { value: '#9F39DB', label: 'Purple Heart' },
    { value: '#41EAD4', label: 'Turquoise' },
    { value: '#6C58D0', label: 'Blue Marguerite' },
    { value: '#7B3F00', label: 'Cinnamon' },
    { value: '#04F06A', label: 'Spring Green' },
    { value: '#FA7921', label: 'Ecstasy' },
    { value: '#367588', label: 'Teal Blue' },
    { value: '#FF9FE5', label: 'Lavender Rose' },
    { value: '#0000ff', label: 'Blue' },
    { value: '#79B473', label: 'Fern' },
    { value: '#192A51', label: 'Nile Blue' },
    { value: '#D7F171', label: 'Sulu' },
    { value: '#F2B5D4', label: 'Azalea' },
    { value: '#586994', label: 'Waikawa Gray' },
    { value: '#E7086D', label: 'Razzmatazz' },
    { value: '#9EEFE5', label: 'Blizzard Blue' },
    { value: '#744677', label: 'Affair' },
    { value: '#8CD867', label: 'Pastel Green' },
    { value: '#38369A', label: 'Chambray' },
    { value: '#FF8E72', label: 'Salmon' },
    { value: '#2C666E', label: 'Casal' },
    { value: '#7209B7', label: 'Purple' },
    { value: '#850A25', label: 'Monarch' },
    { value: '#DFE208', label: 'Bitter Lemon' },
    { value: SENSE_BRAND_COLOR, label: 'Sense' },
    { value: '#88D9E6', label: 'Cornflower' },
    { value: '#9acd32', label: 'Atlantis' },
    { value: '#3A5683', label: 'Chambray' },
    { value: '#7F7266', label: 'Sandstone' },
]

export const getRandomColor = () => {
    return COLORS[Math.floor(Math.random() * COLORS.length)]
}

export const getRandomColorIndex = () => {
    return Math.floor(Math.random() * COLORS.length)
}

export const SENSE_COLOR_INDEX = 28

export const getColorByIndex = index => {
    return COLORS[parseInt(index) % COLORS.length] || { value: SENSE_BRAND_COLOR, label: 'Sense' }
}

export const percentToColor = (percent, vibrancyValue = 1) => {
    let r,
        g,
        b = 0
    let h
    if (percent < 50) {
        r = 255
        g = Math.round(5.1 * percent)
        h = r * 0x10000 + g * 0x100 + b
    } else {
        g = 255
        r = Math.round(510 - 5.1 * percent)
        h = r * 0x10000 + g * vibrancyValue * 0x100 + b
    }
    return '#' + ('000000' + h.toString(16)).slice(-6)
}

export const getContrastColor = color => {
    if (!color) return '#000'
    let r,
        g,
        b,
        a = 1

    if (color.startsWith('#')) {
        // Handle both #RGB and #RGBA formats
        const hex = color.replace('#', '')
        if (hex.length === 8) {
            // #RRGGBBAA
            r = parseInt(hex.substr(0, 2), 16)
            g = parseInt(hex.substr(2, 2), 16)
            b = parseInt(hex.substr(4, 2), 16)
            a = parseInt(hex.substr(6, 2), 16) / 255
        } else if (hex.length === 4) {
            // #RGBA
            r = parseInt(hex[0] + hex[0], 16)
            g = parseInt(hex[1] + hex[1], 16)
            b = parseInt(hex[2] + hex[2], 16)
            a = hex[3] ? parseInt(hex[3] + hex[3], 16) / 255 : 1
        } else if (hex.length === 6) {
            // #RRGGBB
            r = parseInt(hex.substr(0, 2), 16)
            g = parseInt(hex.substr(2, 2), 16)
            b = parseInt(hex.substr(4, 2), 16)
        } else if (hex.length === 3) {
            // #RGB
            r = parseInt(hex[0] + hex[0], 16)
            g = parseInt(hex[1] + hex[1], 16)
            b = parseInt(hex[2] + hex[2], 16)
        } else {
            throw new Error('Invalid hex color format')
        }
    } else if (color.startsWith('rgba')) {
        // RGBA format
        const rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',')
        r = parseInt(rgba[0])
        g = parseInt(rgba[1])
        b = parseInt(rgba[2])
        a = rgba[3] !== undefined ? parseFloat(rgba[3]) : 1
    } else if (color.startsWith('rgb')) {
        // RGB format
        const rgb = color.replace(/^rgb?\(|\s+|\)$/g, '').split(',')
        r = parseInt(rgb[0])
        g = parseInt(rgb[1])
        b = parseInt(rgb[2])
    } else {
        throw new Error('Invalid color format. Please provide hex, rgb, or rgba.')
    }

    // Blend with white background based on alpha
    if (a < 1) {
        r = Math.round(r * a + 255 * (1 - a))
        g = Math.round(g * a + 255 * (1 - a))
        b = Math.round(b * a + 255 * (1 - a))
    }

    // Calculate relative luminance using sRGB coefficients
    const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255
    return lum > 0.5 ? '#000' : '#fff'
}

export const hexToRgba = (hex, opacity) => {
    const hexValue = hex.replace('#', '')
    const r = parseInt(hexValue.substring(0, 2), 16)
    const g = parseInt(hexValue.substring(2, 4), 16)
    const b = parseInt(hexValue.substring(4, 6), 16)
    return `rgba(${r}, ${g}, ${b}, ${opacity})`
}
